import React, { useState } from 'react';
import { useFormikContext, FieldArray } from "formik";
import { routeShape } from '../../utils/Shapes';
import { Button } from "reactstrap";
import { useEdit } from '../../Services/EditContext';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tabs';
import Manifest from './Manifest';
import { useEffect } from 'react';
import Modal from '../Models/Modal';
import EditorTitle from '../Models/EditorTitle';
import entities from '../../utils/entities';
import useFunction from '../../utils/Hooks/useFunction';
import FormContainer from '../Models/FormContainer';
import FlightRow from './FlightRow';
import { ICharterRequest } from '../../Models/ICharterRequest';
import { IRoute } from '../../Models/IRoute';

type Props = {
    route: string;
    noEdit?: boolean;
    showEditManifest?: boolean;
} & Record<string, unknown>;

const FlightRoute = ({ route, purchase, share, compare, noEdit, placeBid, newRequest, showEditManifest }: Props) => {
    const [edit] = useEdit();
    const { setFieldValue, values } = useFormikContext<ICharterRequest & { activeTab: string }>();
    const { routes, activeTab } = values;
    const [editManifest, setEditManifest] = useState(showEditManifest);
    const [handleSubmit, setHandleSubmit] = useFunction() as [(params?: unknown) => unknown, React.Dispatch<(params?: unknown) => unknown>];
    const [isSubmitting, setSubmit] = useState();

    useEffect(() => {
        if (newRequest && edit && !placeBid) {
            if (activeTab === 'Return') {
                if (routes.length === 1) {
                    const newRoute2 = { ...routes[0], from: routes[0].to, to: routes[0].from, manifest: [] };
                    setFieldValue('routes', [routes[0], newRoute2]);
                }
            }

            else if (!activeTab || activeTab === 'Multi') {
                if (routes.length < 2) {
                    setFieldValue('routes', [{ ...routeShape }, { ...routeShape }]);
                }
            }
            else if (activeTab === 'OneWay') {
                if (routes.length > 1) {
                    const [theRoute] = routes;
                    setFieldValue('routes', [theRoute]);
                }
            }
        }

    }, [activeTab, routes, edit, newRequest, placeBid, setFieldValue])
    const setActiveTab = (tab: string) => {
        setFieldValue('activeTab', tab)
    }
    const NewActions = () => {
        const handleClick = () => {
            handleSubmit();
        }
        return isSubmitting ? null : <Button onClick={handleClick}>Save</Button>
    }
    const saveManifest = (newValues: { routes: IRoute[], shareManifest: boolean }) => {
        const routes = newValues.routes;
        const shareManifest = newValues.shareManifest;
        const newRoutes = routes?.map(x => {
            const manifest = shareManifest ? routes[0].manifest : x.manifest;
            if (manifest && manifest.length) {
                x.passengerNumber = manifest.length;
                x.totalWeight = manifest.reduce((a, x) => a + (x.freightWeight ? x.freightWeight : 0) + (x.cargoWeight ? x.cargoWeight : 0) + (x.passengerWeight ? x.passengerWeight : 0), 0);
            }
            x.manifest = manifest;
            return x;
        })

        setFieldValue('routes', newRoutes);
        if (!edit) {

        }
        setEditManifest(false);


    }
    return <React.Fragment>
        <Modal open={!!editManifest} onClose={() => setEditManifest(false)} title={<EditorTitle entity={entities.manifest} detail={values} />} actions={<NewActions />}  >
            <FormContainer initialValues={{ ...values }} validationSchema={entities.manifest.validationSchema} edit={edit} setHandleSubmit={setHandleSubmit} onSubmit={saveManifest} setSubmitting={setSubmit}>
                <Manifest newRequest />
            </FormContainer >
        </Modal>




        {newRequest && edit && !noEdit ?
            <Tabs className='charterTabParent' onSelect={setActiveTab} activeKey={activeTab ? activeTab : 'Multi'} style={{ marginTop: '15px' }}>
                <Tab tabClassName='charterTabItem' className={'charterTab'} key={'OneWay'} eventKey={'OneWay'} title='One Way' style={{ borderLeft: '1px solid black', borderRight: '1px solid black', borderBottom: '1px solid black' }}>
                    {activeTab === 'OneWay' ? <FlightRow route={route} newRequest={newRequest} compare={compare} purchase={purchase} index={0} noEdit={noEdit} placeBid={placeBid} editManifest={editManifest} setEditManifest={setEditManifest} /> : null}
                </Tab>
                <Tab tabClassName='charterTabItem' className={'charterTab'} key={'Return'} eventKey={'Return'} title='Return' style={{ borderLeft: '1px solid black', borderRight: '1px solid black', borderBottom: '1px solid black' }}>
                    {activeTab === 'Return' ? <FlightRow newRequest={newRequest} route={route} compare={compare} purchase={purchase} index={0} noEdit={noEdit} placeBid={placeBid} editManifest={editManifest} setEditManifest={setEditManifest} /> : null}
                    {activeTab === 'Return' && routes.length > 1 ? <FlightRow newRequest={newRequest} route={route} index={1} reverseLast noEdit={noEdit} placeBid={placeBid} editManifest={editManifest} setEditManifest={setEditManifest} /> : null}

                </Tab>
                <Tab tabClassName='charterTabItem' className={'charterTab'} key={'Multi'} eventKey={'Multi'} title='Multi-stop' style={{ borderLeft: '1px solid black', borderRight: '1px solid black', borderBottom: '1px solid black' }}>
                    {!activeTab || activeTab === 'Multi' ?
                        <FieldArray
                            name="routes"
                            render={({ push, remove }) => values.routes && values.routes.length > 0 ? values.routes.map((x, index) =>
                                <FlightRow route={route} newRequest={newRequest} compare={compare} purchase={purchase} multi key={index} index={index} add={() => push({ ...routeShape })} remove={() => remove(index)} noEdit={noEdit} placeBid={placeBid} editManifest={editManifest} setEditManifest={setEditManifest} />
                            ) : null} /> : null}
                </Tab>

            </Tabs> : <FieldArray
                name="routes"
                render={({ insert, remove }) => values.routes && values.routes.length > 0 ? values.routes.map((x, index) =>
                    <FlightRow route={route} newRequest={newRequest} purchase={purchase} share={share} compare={compare} key={x.id ? x.id : (x as any).newId} index={index} insert={() => insert(index, { ...routeShape, newId: Math.floor(Math.random() * 5000) })} add={() => insert(index + 1, { ...routeShape, newId: Math.floor(Math.random() * 5000) })} remove={() => {
                        remove(index)
                    }} noEdit={noEdit} placeBid={placeBid} editManifest={editManifest} setEditManifest={setEditManifest} />
                ) : null} />}
    </React.Fragment>
}

export default FlightRoute;
